<template>
    <div>

        <config-main-title :noright="true">
            Tipo de Etiqueta de Amostra (Anatomia Patológica)
        </config-main-title>

        <div class="form-row mb-3">
            <div class="col col-12 col-md-6 d-flex flex-column">
                <az-input icon="fas fa-search" v-model="search">
                    <template v-slot:buttonposb v-if="false">
                        <importacao service="tipo_etiqueta_amostras" @refresh="load()" />
                    </template>
                </az-input>
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column">
                <div class="btn-group mb-1" role="group" aria-label="Basic example">
                    <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                    @click="viewMode = 'A'">
                        Ativos
                    </button>
                    <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                    @click="viewMode = 'T'">
                        Todos
                    </button>
                </div>
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column">
                <button type="button" class="btn btn-outline-success" @click="incluir ()">
                    Incluir Tipo de Etiqueta
                </button>
            </div>
        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                msg="Nenhuma tipo de etiqueta identificada." 
                icon="fa-solid fa-barcode" />
		</div>

        <div v-if="lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>

                        <span class="badge badge-secondary ml-2">#{{ dado.id_tipo_etiqueta_amostra}}</span>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <div v-else>
                            <span class="badge badge-primary">
                                <i :class="dado.st_icon" v-if="dado.st_icon"></i>
                                <span v-if="dado.st_sigla"> {{ dado.st_sigla }} </span>
                            </span>

                            <template v-if="true">
                                <button type="button" class="btn btn-sm btn-outline-secondary ml-3" @click="acessos(dado)">
                                    <i class="fas fa-user-lock mr-2"></i>
                                    {{ dado.acessos_count }}
                                </button>
                            </template>
                        </div>
                    </span>
                </li>
            </div>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ item && item.id_tipo_etiqueta_amostra ? '' : 'Nova' }}
                            Tipo de Etiqueta de Amostra
                            {{ item && item.id_tipo_etiqueta_amostra ? '#' + item.id_tipo_etiqueta_amostra : '' }}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Descrição"
                                    :validate="validate"
                                    required
                                    v-model="item.st_titulo" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Ícone"
                                    placeholder="Nenhum..."
                                    :validate="validate"
                                    v-model="item.st_icon">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append" v-if="item.st_icon">
                                            <span class="input-group-text">
                                                <i :class="item.st_icon"></i>
                                            </span>
                                        </div>
                                    </template>
                                </az-input>
                            </div>

                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Sigla"
                                    placeholder="Não definida..."
                                    :validate="validate"
                                    v-model="item.st_sigla">
                                </az-input>
                            </div>

                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Dígitos"
                                    type="number"
                                    placeholder="12..."
                                    :validate="validate"
                                    v-model="item.in_digitos">
                                </az-input>
                            </div>
                        </div>

                        <!-- Sinalizador -->
                        <div class="form-row">
                            <div class="col col-12">
                                <az-input 
                                    label="Sinalizador"
                                    placeholder="Nenhum..."
                                    type="select" 
                                    optionsMode="aql"
                                    service="sinalizadores.index"
                                    :optionsParm="{ ativos: true }"
                                    optionsData="id_sinalizador_atendimento"
                                    v-model="item.id_sinalizador_atendimento">
                                </az-input>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Layout EPL"
                                    placeholder="Não informado..."
                                    :validate="validate"
                                    type="textarea"
                                    rows="10"
                                    v-model="item.st_layout_epl" />
                            </div>
                        </div>

                        <div class="row mt-2">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    label="Selecionar Cassete"
                                    type="checkbox-group"
                                    :validate="validate"
                                    v-model="item.fl_selec_cassete" />
                            </div>
                        </div>

                        <template v-if="item.fl_selec_cassete">

                            <az-sub-title class="mt-3" title="Opções" :info_sm="true">
                                <a href="#" @click.prevent="incluir_opcao()" class="card-link">
                                    <i class="fa-solid fa-plus mr-2"></i> Incluir
                                </a>
                            </az-sub-title>

                            <div v-if="!item.js_opcoes || !item.js_opcoes.length">
                                Nenhum registro de opção realizado.
                            </div>

                            <div v-else>
                                <div class="form-row" v-for="(opcoes, iox) in item.js_opcoes" :key="iox">
                                    <div class="col col-12 col-md-8">
                                        <az-input
                                            sizing="sm"
                                            placeholder="Nome..."
                                            v-model="opcoes.nome">
                                            <template v-slot:button-pre>
                                                <div class="input-group-prepend">
                                                    <button class="btn btn-outline-danger" type="button" @click.prevent="item.js_opcoes.splice(iox, 1)">
                                                        <i class="fa fa-minus" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                    <div class="col col-12 col-md-4">
                                        <az-input
                                            sizing="sm"
                                            placeholder="Sigla..."
                                            v-model="opcoes.sigla">
                                        </az-input>
                                    </div>
                                </div>
                            </div>

                            <!-- Carimbo -->
                            <div class="form-row mt-3">
                                <div class="col col-12">
                                    <az-input 
                                        label="Carimbar Etiquetas do Tipo..."
                                        placeholder="Nenhuma..."
                                        type="select" 
                                        optionsMode="aql"
                                        service="tipo_etiqueta_amostras.index"
                                        :optionsParm="{ ativos: true }"
                                        optionsData="id_tipo_etiqueta_amostra"
                                        v-model="item.id_tipo_etiqueta_amostra_carimbo">
                                    </az-input>
                                </div>
                            </div>

                        </template>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="tipoEtiquetaAmostra" :id="item.id_tipo_etiqueta_amostra" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_tipo_etiqueta_amostra ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <edicao-acessos ref="acessos" @refresh="load()" />

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import Importacao from '../shared/Importacao.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import EdicaoAcessos from '../shared/EdicaoAcessos.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
        }
    },

    props: ['cadastro'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton,
        Importacao,
        AzSubTitle, 
        EdicaoAcessos, 
    },

    computed: { 
        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },

    },

    methods: { 
        acessos(item) { 
          this.$refs.acessos.abrir(
              'App\\azure\\tipoEtiquetaAmostra', 
              item.id_tipo_etiqueta_amostra
            );
        },

        incluir_opcao () { 
            if ( !this.item.js_opcoes ) { 
                this.$set (this.item, 'js_opcoes', [] );
            }

            this.item.js_opcoes.push({ 
                nome: "", 
            });
        },
        
        incluir () { 
            this.validate = false;

            let item = {
                id_tipo_etiqueta_amostra: null, 
                st_titulo: "", 
                st_sigla: "", 
                st_icon: "", 
                fl_ativo: true, 
                js_opcoes: [], 
                fl_selec_cassete: false, 
                in_digitos: null, 
            };

            this.editar (item);
        },

        load () { 
            this.$util.load(this, { 
                service:'tipo_etiqueta_amostras',
                func: 'index',
                parms: { 
                    cadastro: true, 
                }
            });
        },

        editar (item) { 
            this.validate = false;
            this.item = _.cloneDeep (item);

            $('#edicaoModal').modal('show');
        },

        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'tipo_etiqueta_amostras',
                dados: this.item,
                reload: true, 
                modal: 'edicaoModal',
            });
        },

        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },
        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'tipo_etiqueta_amostras',
                dados: item,
            });

        },
    },

    mounted () { 
        this.load ();

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Tipo de Etiqueta de Amostra", method: this.fechar },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>